<template>
  <div class="bg-dark">
    <h3 style="color: #fff">Selamat Hari Raya</h3>
    <div>
      <b-button variant="outline-primary" @click="setImage('ketupat')"
        >Ketupat</b-button
      >
      <b-button variant="outline-secondary" @click="setImage('garlands')"
        >Garlands</b-button
      >
      <b-button variant="outline-success" @click="setImage('lantern')"
        >Lantern</b-button
      >
      <b-button variant="outline-info" @click="setImage('mosque')"
        >Mosque</b-button
      >
      <b-button variant="outline-danger" @click="setImage('eid-al-fitr')"
        >Eid</b-button
      >
      <b-button variant="outline-warning" @click="setImage('eid-al-fitr2')"
        >Eid</b-button
      >
    </div>

    <div>
      <snowing v-bind="snowConf" :images="images" :show="showSnow"></snowing>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    snowConf: {
      windPower: 0.2,
      speed: 1,
      count: 30,
      size: 20,
      opacity: 1,
    },
    images: [
      require("../../assets/raya/ketupat.png"),
      require("../../assets/raya/garlands.png"),
      require("../../assets/raya/lantern.png"),
    ],
    type: "all",
    showSnow: false,
  }),
  components: {
    snowing: require("./Snowing").default,
  },
  methods: {
    setImage(type) {
      this.showSnow = false;
      var image_path = require("../../assets/raya/ketupat.png");

      if (type == "garlands") {
        this.type = "garlands";
        image_path = require("../../assets/raya/garlands.png");
      } else if (type == "mosque") {
        this.type = "mosque";
        image_path = require("../../assets/raya/mosque.png");
      } else if (type == "lantern") {
        this.type = "lantern";
        image_path = require("../../assets/raya/lantern.png");
      } else if (type == "eid-al-fitr") {
        this.type = "eid-al-fitr";
        image_path = require("../../assets/raya/eid-al-fitr.png");
      } else if (type == "eid-al-fitr2") {
        this.type = "eid-al-fitr2";
        image_path = require("../../assets/raya/eid-al-fitr2.png");
      } else {
        this.type = "ketupat";
      }
      this.images = [image_path];
      this.showSnow = true;
    },
  },
  mounted() {
    this.setImage("ketupat");
  },
};
</script>
